angular.module('ikeweb.error').controller('ErrorController', ['$scope', '$stateParams',

    function($scope, $stateParams) {

        var Errors = {
            sharedCaptureNotFound: {
                title: 'Shared capture not found',
                message: 'The shared capture you\'re trying to view cannot be found. It may no longer exist.'
            },
            unknown: {
                title: 'Unknown Error',
                message: 'An unknown error has occurred.'
            }
        };

        var key = $stateParams.errorKey;

        $scope.errorTitle = Errors[key] ? Errors[key].title : Errors.unknown.title;
        $scope.errorMessage = Errors[key] ? Errors[key].message : Errors.unknown.message;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/error/error.controller.js
// module id = 437
// module chunks = 0